import React, { Component } from 'react'


export default class PeaceMain extends Component {

    render() {

        const WrapperStyle = {
            backgroundImage : 'url("/main.jpg")',
            minHeight : '100vh',
            backgroundPosition : 'center',
            backgroundRepeat : 'no-repeat',
            backgroundSize : 'cover',
            backgroundAttachment : 'fixed'
        }


        return (

            <div style={WrapperStyle}>
                <p></p>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/peace/PeaceMain.js